<template>
  <div class="divider-edit">
    <style-bar :css-keys="['background', 'color', 'textAlign']" class="mb-2" mode="text" :styles.sync="localStyles"></style-bar>
    <!-- <v-text-field hide-details placeholder="Section Title" v-model="form.content" label="Divider Title"></v-text-field> -->
    <rich-text-input :style="localStyles" class="py-2 px-4" mode="input" :placeholder="$t('divideredit_section_title_placeholder')" :content.sync="form.content" :json.sync="editorContentJson" :label="$t('divideredit_divider_title')"></rich-text-input>
  </div>
</template>

<script>

import RichTextInput from '@/components/utils/RichTextInput'
import StyleBar from '@/components/utils/StyleBar'

export default {
  name: 'DividerEdit',
  props: ['content', 'styles'],
  components: {
    RichTextInput,
    StyleBar
  },
  data () {
    return {
      editorContentJson: {},
      localStyles: {},
      form: {
        content: ''
      }
    }
  },
  created () {
    this.form.content = this.content
    if (typeof this.form.content !== 'string') {
      this.form.content = ''
    }
    if (this.styles) {
      this.localStyles = JSON.parse(JSON.stringify(this.styles))
    }
  }
}

</script>

<style lang="sass" scoped>

.divider-edit
  background: #f1f1f1

</style>
